import { useState } from 'react';
import { useHistory } from 'react-router';
import en from '../../../../lang/en-us';
import { SCHEMES_RESPONSE } from '../../../../redux-store/types/portfolio';
import { SwitchFlowType } from './types';
import { RootStateType } from '../../../../redux-store/reducers';
import SchemeList from './SchemeList';
import { useSelector } from 'react-redux';
import { SwipeableDrawer } from '@material-ui/core';
import { KYCCheck } from '../../../common/KYCCheck';
import { formatAsIndianCurrency } from '../../../../utils/currency';
import FatcaCheck from '../../../common/FatcaCheck';
import { TRXN_TYPE_MAP } from '../utils';
import { PanSeedCheckNew } from '../../../common/PanSeedCheckNew';

const { dbCommercial } = en;

type Props = {};

const SwitchTo = (props: Props) => {
    const history = useHistory<SwitchFlowType>();
    const [fromSchemeDrawer, setFromSchemeDrawer] = useState<boolean>(false);
    const { switchFromScheme } = history.location.state || {};
    const {
        portfolios: { data: portfolioData },
    }: any = useSelector(({ portfolio }: RootStateType) => ({
        ...portfolio,
    }));

    const currentFundSchemes =
        !!portfolioData && !!switchFromScheme
            ? portfolioData
                  .find((fundData: any) => fundData.schemes[0].amc === switchFromScheme.amc)
                  ?.schemes?.filter(
                      (scheme: SCHEMES_RESPONSE) => scheme.isin !== switchFromScheme.isin,
                  ) || []
            : [];
    return (
        <div className="curved-bg switch-to">
            <KYCCheck
                allowRegistration={{ isin: switchFromScheme?.isin, amc: switchFromScheme?.amc }}
            />
            <PanSeedCheckNew
                customPayload={{
                    taxStatus: switchFromScheme?.taxStatus,
                    amc: switchFromScheme?.amc,
                    folio: String(switchFromScheme?.folio),
                    trxnMode: "FT",
                    trxnType: TRXN_TYPE_MAP.switch
                }}
                callBackFn={() => {}}
                triggerCheck={true}
            />
            <FatcaCheck rtaName={switchFromScheme?.rtaName} />
            <h2 className="heading">
                <a onClick={() => history.goBack()}>
                    <img src="/images/left-arrow-black.svg" alt="icon" />
                </a>
                {dbCommercial.switch.heading}
            </h2>
            <h4 className="switch-from-heading">{dbCommercial.switch.selectedSwitchFrom}</h4>
            <div className="switch-from">
                <h3>
                    <span>{switchFromScheme?.schemeName}</span>
                    <a className="mobile_mode" onClick={() => setFromSchemeDrawer(true)}>
                        {dbCommercial.switch.viewDetails}
                    </a>
                </h3>
                {/* <a>
                    <img src="/images/edit-icon-filled.svg" alt="icon" />
                    {dbCommercial.switch.edit}
                </a> */}
                <div className="switch-from-info desktop_mode">
                    <div className="switch-from-txt">
                        <h6>{dbCommercial.switch.folioNo}</h6>
                        <p>{switchFromScheme?.folio}</p>
                    </div>
                    <div className="switch-from-txt">
                        <h6>{dbCommercial.switch.totalBalanceUnits}</h6>
                        <p>{switchFromScheme?.availableUnits}</p>
                    </div>
                    <div className="switch-from-txt">
                        <h6>{dbCommercial.switch.currentNav}</h6>
                        <p>
                            {formatAsIndianCurrency(switchFromScheme?.nav || 0)}
                            <img src="/images/calender-icon.svg" alt="icon" />
                            <span>
                                {dbCommercial.switch.asOn}
                                <b>{switchFromScheme?.navDate}</b>
                            </span>
                        </p>
                    </div>
                </div>
            </div>
            <h4>{dbCommercial.switch.switchToInfo}</h4>
            <SchemeList existingFunds={currentFundSchemes} fromScheme={switchFromScheme} />
            <div className="curved-bg-content-inner-bottom">
                <div className="table-submit">
                    {/* <Button
                        className="customBtn"
                        disabled={!selectedRows.length}
                        onClick={onHandleSubmit}
                    >
                        {dashboard.ChangeDividend.buttonText}
                    </Button> */}
                </div>
            </div>
            <SwipeableDrawer
                anchor={'bottom'}
                open={fromSchemeDrawer}
                onClose={() => setFromSchemeDrawer(false)}
                onOpen={() => setFromSchemeDrawer(true)}
                className="scheme-from-drawer"
            >
                <div className="switch-from">
                    <h3>
                        <span>{switchFromScheme?.schemeName}</span>
                    </h3>
                    <div className="switch-from-info">
                        <div className="switch-from-txt">
                            <h6>{dbCommercial.switch.folioNo}</h6>
                            <p>{switchFromScheme?.folio}</p>
                        </div>
                        <div className="switch-from-txt">
                            <h6>{dbCommercial.switch.totalBalanceUnits}</h6>
                            <p>{switchFromScheme?.closingBalance}</p>
                        </div>
                        <div className="switch-from-txt">
                            <h6>{dbCommercial.switch.currentNav}</h6>
                            <p>
                                {switchFromScheme?.nav}
                                <img src="/images/calender-icon.svg" alt="icon" />
                                <span>
                                    {dbCommercial.switch.asOn}
                                    <b>{switchFromScheme?.navDate}</b>
                                </span>
                            </p>
                        </div>
                    </div>
                </div>
            </SwipeableDrawer>
        </div>
    );
};

export default SwitchTo;
